<div class="full-width has-nav">
    <div class="container w-6 m-auto">
        <h1>Mentions légales</h1>
        <h2>Présentation Du Site</h2>
        <p>
            Les explorateurs du monde (https://www.lesexplorateursdumonde.com) est un blog personnel hébergé chez OVH, dont le siège social
            est situé 2 rue Kellermann – 59100 Roubaix – France.
            <br />L’éditeur responsable du site est Romain Duvillier explorateurs&#64;lesexplorateursdumonde.com
            <b>Les Explorateurs du Monde</b><br />
            <b>TVA : BE1006.173.179</b>
        </p>
        <h2>Politique De Confidentialité</h2>
        <h3>Cookies</h3>
        <p>
            La navigation sur lesexplorateursdumonde.com est susceptible de provoquer l’installation de cookie(s) sur votre ordinateur.<br />
            Un cookie est un fichier de petite taille, qui ne permet pas votre identification, mais qui enregistre des informations
            relatives à la navigation d’un ordinateur sur un site.<br />
            Les données ainsi obtenues visent à faciliter la navigation ultérieure sur le site, et ont également vocation à permettre
            diverses mesures de fréquentation.<br />
            Ce site utilise Google Analytics, le service d’analyse du trafic des sites internet qui se sert de ces cookies.<br />
            Les données récoltées dans le cadre de l’analyse du trafic du site et de l’optimisation des services sont conservées durant la
            période minimale proposée par Google, c’est-à-dire 14 mois.<br />
            Les données récoltées via les cookies ne sont en aucun cas vendues à des tiers. Certaines données générales comme le nombre de
            visiteurs ou les pays d’origine des visiteurs peuvent être communiquées de manière occasionnelle lors de partenariats afin
            d’attester de la fréquentation de ce blog .
        </p>
        <h3>Contenu embarqué depuis d’autres sites</h3>
        <p>
            Les articles de ce site peuvent inclure des contenus intégrés (par exemple des vidéos, images, articles…).<br />
            Le contenu intégré depuis d’autres sites se comporte de la même manière que si le visiteur se rendait sur cet autre site.<br />
            Ces sites web pourraient collecter des données sur vous, utiliser des cookies, embarquer des outils de suivis tiers, suivre vos
            interactions avec ces contenus embarqués si vous disposez d’un compte connecté sur leur site web.
        </p>
        <h3>Commentaires</h3>
        <p>
            Si vous laissez un commentaire, le commentaire et ses métadonnées sont conservés indéfiniment.<br />
            Cela permet de reconnaître et approuver automatiquement les commentaires suivants au lieu de les laisser dans la file de
            modération.<br />
            Les commentaires des visiteurs peuvent être vérifiés à l’aide d’un service automatisé de détection des commentaires
            indésirables.
        </p>
        <h2>Propriété Intellectuelle</h2>
        <p>
            Les éléments suivants sont la propriété intellectuelle de l’éditeur du site, et ne peuvent être utilisés sur d’autres supports,
            complètement ou partiellement, sans son autorisation.
        </p>
        <h3>Photos</h3>
        <p>
            Sauf mention contraire dans la légende, les photos sont la propriété exclusive de Les explorateurs du monde - Estelle Walravens
            et/ou Romain Duvillier. Elles ne peuvent donc pas être utilisées sans accord.<br />
            Seul le partage de photos sur les réseaux sociaux (Facebook, Instagram, Twitter, Pinterest) mentionnant explicitement
            lesexplorateursdumonde.com et le nom d’utilisateur correspondant au réseau social en question (&#64;lesexplorateurs.dumonde) est
            autorisé.<br />
            L’utilisation dans des articles, magazines, journaux, etc n’est pas autorisée et n’est pas libre de droit. Si vous souhaitez
            acquérir une photo pour une utilisation autre que celle décrite ci-dessus, veuillez nous contacter
            (explorateurs&#64;lesexplorateursdumonde.com).
        </p>
        <h3>Articles</h3>
        <p>
            Les courtes citations du contenu (extrait d’article) sont autorisées, sous réserve que soient indiqués clairement le nom de
            l’auteur et de la source, par le biais d’un lien vers une des pages de ce site web : sur un site web ou un blog, dans les
            conditions suivantes :<br />
            limitation à 300 caractères, suivis de la mention « Source : » suivie d’un lien composé de l’URL de l’article d’origine.<br />
            Le lien ne doit pas comporter d’attribut « rel= »nofollow » » sur un support papier (presse écrite), dans les conditions
            suivantes :<br />
            limitation à 500 caractères, précédés ou suivis de la mention « Source : www.lesexplorateursdumonde.com »<br />
            Si vous souhaitez acquérir un texte pour une utilisation autre que celle décrite ci-dessus, veuillez nous contacter
            (explorateurs&#64;lesexplorateursdumonde.com).<br />
            Pour rappel, la violation des droits d’auteurs est constitutive du délit de contrefaçon.
        </p>
        <h2>Limite De Responsabilité</h2>
        <p>
            Les propos tenus sur ce blog sont l’expression d’opinions personnelles et non exclusives.<br />
            Les liens hypertextes vers des sites externes ont pour vocation de vous permettre d’approfondir un sujet ou de mentionner une
            source.<br />
            Nous ne pouvons pas être tenus responsables d’un problème d’accès à ce site internet (lié à une maintenance ou problème
            informatique).<br />
            Nous nous réservons le droit de modérer, modifier ou supprimer tout commentaire.<br />
            Le non respect de l’une des règles suivantes entraîne la suppression du commentaire :
        </p>
        <ul>
            <li>
                <p>Commentaires diffamatoires, racistes, pornographiques, pédophiles, incitant à délit, crime ou suicide</p>
            </li>
            <li>
                <p>Commentaires reproduisant une correspondance privée sans l’accord des personnes concernées</p>
            </li>
            <li>
                <p>Commentaires agressifs ou vulgaires</p>
            </li>
            <li>
                <p>Commentaires visant uniquement à mettre en ligne un lien vers un site extérieur</p>
            </li>
        </ul>
    </div>
</div>
